<template>

  <div>
    <div class="box" v-if="(!areAnyExercises || seznamPodskupin.length > 0) && adminView">
      <div>
        <div class="box-header with-border">
          <h3 class="box-title">{{$t("pages.adminpanel.exercises.bannerName")}}</h3>
          <div v-if="detectMobile()" class="pull-right">
            <button type="button" class="btn btn-success btn-sm createBtn btn-margin col-xs-12" @click.prevent="colapseCreateSubgroup(1)"><i class="fa fa-plus"></i> {{$t('pages.subgroups.createSubGroup')}}</button>
            <button type="button" class="btn btn-success btn-sm createBtn btn-margin col-xs-12" @click.prevent="openAddExam"><i class="fa fa-plus"></i> {{$t('pages.exams.createExam')}}</button>
            <button type="button" class="btn btn-success btn-sm createBtn btn-margin col-xs-12" @click.prevent="toggleReorderSubgroups()"><i class="fa fa-reorder"></i> {{$t('pages.subgroups.reorder')}}</button>
            <button type="button" class="btn btn-success btn-sm createBtn btn-margin col-xs-12" @click.prevent="recomputeGroup()">{{$t('pages.subgroups.exportGroup')}}</button>
          </div>
          <div v-else-if="toggleStatus" class="pull-right">
            <div v-if="statusProgress == -1" class="text-red">
              <span v-if="statusType === 'YAML import'"> {{$t('pages.subgroups.yamlError')}}</span>
              <span v-else-if="statusType === 'Recompute group'"> {{$t('pages.subgroups.recomputeError')}}</span>
              <button type="button" class="btn btn-default createBtn" @click.prevent="openDetailsModal()">{{$t('pages.buttons.details')}}</button>
              <button type="button" class="btn btn-default createBtn" @click.prevent="refreshGroup()">{{$t('pages.buttons.back')}}</button>
            </div>
            <div v-else-if="statusProgress == 100" class="text-green">
              <span v-if="statusType === 'YAML import'"> {{$t('pages.subgroups.yamlSuccess')}}</span>
              <span v-else-if="statusType === 'Recompute group'"> {{$t('pages.subgroups.recomputeSuccess')}}</span>
              <button v-if="statusType === 'Recompute group'" type="button" class="btn btn-default createBtn" @click.prevent="openDetailsModal()">{{$t('pages.buttons.details')}}</button>
              <button type="button" class="btn btn-default createBtn" @click.prevent="refreshGroup()">{{$t('pages.buttons.refresh')}}</button>
            </div>
            <div v-else>
              <span class="text-yellow">{{$t('pages.subgroups.pleaseWait')}}.
                <span v-if="statusType === 'YAML import'"> {{$t('pages.subgroups.yamlProgress')}}</span>
                <span v-else-if="statusType === 'Recompute group'"> {{$t('pages.subgroups.recomputeProgress')}}</span>
                <span v-if="statusProgress < 100"> {{$t('pages.subgroups.progress')}}: {{statusProgress}}%</span>
              </span>
              <pulse-loader class="loader" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
            </div>
          </div>
          <div v-else class="btn-group pull-right">
            <button type="button" class="btn btn-success createBtn" @click.prevent="colapseCreateSubgroup(1)"><i class="fa fa-plus"></i> {{$t('pages.subgroups.createSubGroup')}}</button>
            <button type="button" class="btn btn-success createBtn" @click.prevent="openAddExam"><i class="fa fa-plus"></i> {{$t('pages.exams.createExam')}}</button>
            <button type="button" class="btn btn-success createBtn" @click.prevent="toggleReorderSubgroups()"><i class="fa fa-reorder"></i> {{$t('pages.subgroups.reorder')}}</button>
            <button type="button" class="btn btn-success createBtn" @click.prevent="recomputeGroup()">{{$t('pages.subgroups.recomputeGroup')}}</button>
            <button v-if="sid == 'root'" class="btn btn-success createBtn" @click.prevent="openImport()">{{$t('pages.subgroups.importStructure')}}</button>
            <button class="btn btn-success createBtn" @click.prevent="exportGroup()">{{$t('pages.subgroups.exportGroup')}}</button>
            <button v-if="sid == 'root'" type="button" class="btn btn-success createBtn" @click.prevent="goToGradebook()">{{$t('pages.gradebook.title')}}</button>
          </div>
        </div>
        <!-- /.box-header -->

        <div v-if="!colCS" class="small-box-footer">
          <!-- add edit component-->
          <br>
          <createsubgroup :sid="sid" :gid="gid"></createsubgroup>
          <!-- add edit component-->
        </div>
      </div>
    </div>

    <div v-if="!hideGroups">
      <div v-if="(!areAnyExercises || seznamPodskupin.length > 0)">
      <div v-if="detectMobile()">
        <div style="padding: 10px; margin-bottom: 0px !important;" data-toggle="collapse" href="#collapse1" :class="['no-padding-box', 'content', possibleColors[3], 'subgroup-box', 'group-box', 'info-box', 'containter-fluid']" @click.prevent="toggleExamsShown()">
          <h3 class="small-margin-text info-box-number" :class="{'left-margin-text':!detectMobile()}">
            <span>
              <!-- <i v-if="examsOpened" class="fa fa-folder-open"></i>
              <i v-else class="fa fa-folder"></i> -->
              <i class="fa fa-clock-o"></i>
            </span>
            {{$t('pages.subgroups.examsAndQuizzes')}}
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-default" @click.prevent.stop="showRatingQuizSelection">
                {{$t('pages.subgroups.generatedQuiz')}}
              </button>
            </div>
          </h3>
          <!-- <div class="progress">
            <div class="progress-bar" :style="{width: (0)*100 + '%'}"></div>
          </div> -->
          <span v-if="examsOpened" class="small-margin-text progress-description" style="margin-top: 10px">
            {{$t('pages.subgroups.examsAndQuizzesDescriptionNotCollapsed')}}
          </span>
          <span v-else class="small-margin-text progress-description" style="margin-top: 10px">
            {{$t('pages.subgroups.examsAndQuizzesDescriptionCollapsed')}}
          </span>
        </div>
      </div>
      <div v-if="sid != 'root' && !detectMobile()">
        <div style="margin-bottom: 0px !important;" data-toggle="collapse" href="#collapse1" :class="['no-padding-box', 'content', possibleColors[3], 'subgroup-box', 'info-box', 'containter-fluid']" @click.prevent="toggleExamsShown()">
          <div class="group-box">
            <span class="small-icon info-box-icon" :class="[]">
              <i class="fa fa-clock-o"></i>
            </span>
            <div style="padding: 10px">
              <h3 class="small-margin-text info-box-number left-margin-text">
                {{$t('pages.subgroups.examsAndQuizzes')}}
                <div class="btn-group pull-right">
                  <button type="button" class="btn btn-default" @click.prevent.stop="showRatingQuizSelection">
                    {{$t('pages.subgroups.generatedQuiz')}}
                  </button>
                </div>
              </h3>
              <span v-if="examsOpened" class="left-margin-text small-margin-text progress-description" style="margin-top: 7px">
                {{$t('pages.subgroups.examsAndQuizzesDescriptionNotCollapsed')}}
              </span>
              <span v-else class="left-margin-text small-margin-text progress-description" style="margin-top: 7px">
                {{$t('pages.subgroups.examsAndQuizzesDescriptionCollapsed')}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Literature implemenetation -->
      <!--<div v-if="sid == 'root' && !detectMobile()" class="group-box small-box info-box" :class="[possibleColors[5]]" @click.prevent="goToLiterature()">
        <div>
          <span class="info-box-icon">
            <i class="fa fa-book" aria-hidden="true"></i>
          </span>
          <div class="info-box-content">
            <h3 class="info-box-number">
              {{$t('pages.literature.literature')}}
            </h3>
          </div>
        </div>
      </div>-->
      <!-- End of literature implementation -->
      <div v-if="sid == 'root' && !detectMobile()" class="group-box small-box info-box containter-full" data-toggle="collapse" href="#collapse1" :class="[possibleColors[3]]" @click.prevent="toggleExamsShown()" style="margin-bottom: 0px !important;">
        <div>
          <span class="info-box-icon">
            <!-- <i v-if="examsOpened" class="fa fa-folder-open-o"></i>
            <i v-else class="fa fa-folder-o"></i> -->
            <i class="fa fa-clock-o"></i>
          </span>
          <div class="info-box-content">
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-default" @click.prevent.stop="showRatingQuizSelection" style="margin-top: 5px">
                {{$t('pages.subgroups.generatedQuiz')}}
              </button>
            </div>
            <h3 class="info-box-number">
              {{$t('pages.subgroups.examsAndQuizzes')}}
            </h3>
            <!-- <div class="progress">
              <div class="progress-bar" :style="{width: (0)*100 + '%'}"></div>
            </div> -->
            <span v-if="examsOpened" class="progress-description">
              {{$t('pages.subgroups.examsAndQuizzesDescriptionNotCollapsed')}}
            </span>
            <span v-else class="progress-description">
              {{$t('pages.subgroups.examsAndQuizzesDescriptionCollapsed')}}
            </span>
          </div>
        </div>
      </div>
      <div class="panel-group" style="margin-bottom: 15px !important;">
        <div class="panel panel-default">
          <div id="collapse1" class="panel-collapse collapse">
            <div class="panel-body" style="padding-bottom: 0px !important;">
              <div v-if="seznamKvizov && seznamKvizov.length <= 0">
                <p>{{$t('pages.subgroups.noQuizzes')}}</p>
              </div>
              <div v-for="(kviz, index) in seznamKvizov" :key="'kviz-'+kviz.id">
                <div v-if="detectMobile()">
                  <div style="padding: 10px" :class="['no-padding-box', 'content', kviz.isExam ? possibleColors[2] : possibleColors[3], 'subgroup-box', 'group-box', 'info-box', 'containter-fluid']" @click.prevent="showExamInfo(kviz)">
                    <div class="btn-group pull-right">
                      <button type="button" class="btn btn-default btn-xs" @click.prevent.stop="editTopic(kviz, index)" v-if="adminView">
                        <i class="fa fa-edit"></i>
                      </button>
                      <!-- Kviz za predavanja -->
                      <button type="button" class="btn btn-default btn-xs" v-if="adminView" style="margin-left: 0.25em;" @click.prevent.stop="$refs.examResultsPreview.showCurrentResults(kviz.id)">
                        <i class="fa fa-archive"></i>
                      </button>
                      <!-- /Kviz za predavanja -->
                      <!-- TO-DO -->
                      <button type="button" class="btn btn-default btn-xs" v-if="adminView" style="margin-left: 0.25em;" @click.prevent.stop="exportCSV(kviz.id)">
                        .csv
                      </button>
                      <button type="button" class="btn btn-default btn-xs" v-if="adminView" style="margin-left: 0.25em;" @click.prevent.stop="showExamResults(kviz)">
                          {{$t('pages.exams.showAttempts')}}
                        </button>
                    </div>
                    <h3 class="small-margin-text info-box-number" :class="{'left-margin-text':!detectMobile()}">
                      <span v-if="detectMobile()">
                        <i class="fa fa-calendar" v-if="kviz.isExam"></i>
                        <i class="fa fa-hourglass" v-else></i>
                      </span>
                      {{ kviz.title | pickTranslation }}
                      <i v-if="!adminView && kviz.classExams[0] && kviz.classExams[0].isSolving" class="fa fa-spinner"></i>
                    </h3>
                    <div class="progress">
                      <div class="progress-bar" :style="{width: (kviz.totalSolvedQuestionsCount / kviz.totalQuestionsCount)*100 + '%'}"></div>
                    </div>
                    <span class="small-margin-text progress-description">
                      <span class="progress-description" v-for="classExam in kviz.classExams" :key="'class-exam-'+classExam.id">
                        <span v-if="selectedGroup.isOwner"><b>{{classExam.class}}</b></span>
                        <span v-else>{{$t('pages.group.opensAt')}}: {{ classExam.startsAt | formatDate }} {{$t('pages.group.duration')}}: {{classExam.duration/60/1000}} minut</span>
                        <div v-if="classExam.publishedAt && adminView" class="pull-right">
                          <span class="label label-default">{{$t('pages.exams.published')}}</span>
                        </div>
                      </span>
                    </span>
                  </div>
                </div>
                <div v-else-if="sid != 'root'" :key="kviz.id" :class="['no-padding-box', 'content', kviz.isExam ? possibleColors[2] : possibleColors[3], 'subgroup-box', 'info-box', 'containter-fluid']">
                  <div @click.prevent="showExamInfo(kviz)" class="group-box" style="position: relative;">
                    <span v-if="!detectMobile()" class="small-icon info-box-icon" :class="[]" style="height: 100%; position: absolute;">
                      <i v-if="kviz.isExam" class="fa fa-calendar"></i>
                      <i v-else class="fa fa-hourglass"></i>
                    </span>
                    <div style="padding: 10px">
                      <div class="btn-group pull-right">
                        <button type="button" class="btn btn-default btn-xs" @click.prevent.stop="editTopic(kviz, index)" v-if="adminView">
                          <i class="fa fa-edit"></i>
                        </button>
                        <!-- Kviz za predavanja -->
                        <button type="button" class="btn btn-default btn-xs" v-if="adminView" style="margin-left: 0.25em;" @click.prevent.stop="$refs.examResultsPreview.showCurrentResults(kviz.id, 1)">
                          <i class="fa fa-archive"></i>
                        </button>
                        <!-- /Kviz za predavanja -->
                        <!-- TO-DO -->
                        <button type="button" class="btn btn-default btn-xs" v-if="adminView" style="margin-left: 0.25em;" @click.prevent.stop="exportCSV(kviz.id)">
                          .csv
                        </button>
                        <button type="button" class="btn btn-default btn-xs" v-if="adminView" style="margin-left: 0.25em;" @click.prevent.stop="showExamResults(kviz)">
                          {{$t('pages.exams.showAttempts')}}
                        </button>
                      </div>
                      <h3 class="small-margin-text info-box-number" :class="{'left-margin-text':!detectMobile()}">
                      <span v-if="detectMobile()">
                        <i v-if="kviz.isExam" class="fa fa-calendar"></i>
                        <i v-else class="fa fa-hourglass"></i>
                      </span>
                        {{index+1}}. {{ kviz.title | pickTranslation }}
                        <i v-if="!adminView && kviz.classExams[0] && kviz.classExams[0].isSolving" class="fa fa-spinner"></i>
                      </h3>
                      <div class="progress" style="margin-left: 60px">
                        <div class="progress-bar" :style="{width: (kviz.totalSolvedQuestionsCount / kviz.totalQuestionsCount)*100 + '%'}"></div>
                      </div>
                      <span v-if="kviz.classExams.length === 0">&nbsp;</span><!-- Fix za pokvarjen izgled ce ni nobene objavev -->
                      <span class="small-margin-text progress-description" :class="{'left-margin-text':!detectMobile()}" v-for="classExam in kviz.classExams" :key="'e-progress-'+classExam.id">
                        <span v-if="selectedGroup.isOwner"><b>{{classExam.class}}</b> - </span>
                        {{$t('pages.group.opensAt')}}: {{ classExam.startsAt | formatDate }} {{$t('pages.group.duration')}}: {{classExam.duration/60/1000}} minut
                        <div v-if="classExam.publishedAt && adminView" class="pull-right">
                          <span class="label label-default">{{$t('pages.exams.published')}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="group-box small-box info-box containter-full" @click.prevent="showExamInfo(kviz)" :class="[kviz.isExam ? possibleColors[2] : possibleColors[3]]" v-else>
                  <div> <!-- IZPIT -->
                    <span class="info-box-icon" style="position: absolute;">
                      <i v-if="kviz.isExam" class="fa fa-calendar"></i>
                      <i v-else class="fa fa-hourglass"></i>
                    </span>

                    <div class="info-box-content">
                      <div class="btn-group pull-right">
                        <button type="button" class="btn btn-default" @click.prevent.stop="editTopic(kviz, index)" v-if="adminView" style="margin-top: 0.5em">
                          <i class="fa fa-edit"></i>
                        </button>
                        <button type="button" class="btn btn-default" v-if="adminView" style="margin-top: 0.5em; margin-left: 0.25em;" @click.prevent.stop="navigateToFlow(kviz.id)">
                          Poglej potek izpita
                        </button>
                        <!-- Kviz za predavanja -->
                        <button type="button" class="btn btn-default" v-if="adminView" style="margin-top: 0.5em; margin-left: 0.25em;" @click.prevent.stop="$refs.examResultsPreview.showCurrentResults(kviz.id, 1)">
                          <i class="fa fa-archive"></i>
                        </button>
                        <!-- /Kviz za predavanja -->
                        <!-- TO-DO -->
                        <button type="button" class="btn btn-default" v-if="adminView" style="margin-top: 0.5em; margin-left: 0.25em;" @click.prevent.stop="exportCSV(kviz.id)">
                          .csv
                        </button>
                        <button type="button" class="btn btn-default" v-if="adminView" style="margin-top: 0.5em; margin-left: 0.25em;" @click.prevent.stop="showExamResults(kviz)">
                          {{$t('pages.exams.showAttempts')}}
                        </button>
                      </div>
                      <h3 class="info-box-number">
                        {{ kviz.title | pickTranslation }}
                        <i v-if="!adminView && kviz.classExams[0] && kviz.classExams[0].isSolving" class="fa fa-spinner"></i>
                        <!--<i v-if="!adminView && kviz.classExams[0].isSolving" class="fa fa-ellipsis-h"></i>-->
                      </h3>
                      <div class="progress">
                        <div class="progress-bar" :style="{width: (kviz.totalSolvedQuestionsCount / kviz.totalQuestionsCount)*100 + '%'}"></div>
                      </div>
                      <span class="progress-description" v-for="classExam in kviz.classExams">
                        <span v-if="selectedGroup.isOwner"><b>{{classExam.class}}</b> - </span>
                        {{$t('pages.group.opensAt')}}: {{ classExam.startsAt | formatDate }} {{$t('pages.group.duration')}}: {{classExam.duration/60/1000}} minut
                        <div v-if="classExam.publishedAt && adminView" class="pull-right">
                          <span class="label label-default">{{$t('pages.exams.published')}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div v-if="kviz.showEdit" class="small-box-footer">
                    <editsubgroup :podgrupa="kviz"></editsubgroup>
                  </div>
                  <div v-if="kviz.showOrder" class="small-box-footer">
                    <orderexer :podgrupa="kviz"></orderexer>
                    <!-- add edit component-->
                  </div>
                </div>
                <!-- Quiz question before enter -->
                <div class="modal modal-default fade" :id="'kviz' + kviz.id">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                        <h4 class="modal-title">{{$t('pages.exams.examinationInfo')}}</h4>
                      </div>
                      <div class="modal-body">
                        <div class="form-group" v-if="kviz && kviz.classExams && kviz.classExams.length > 0">
                          <div class="text-center">
                            <p> {{kviz.title}}</p>
                            <p v-if="kviz.classExams[0].maxRetries != 0">{{$t('pages.exams.allowedAttempts')}}: {{kviz.classExams[0].maxRetries}} ({{kviz.classExams[0].maxRetries - kviz.classExams[0].retriesCount}} {{$t('pages.exams.remaining')}})</p>
                            <p v-else>{{$t('pages.exams.allowedAttempts')}}: {{$t('pages.exams.noLimit')}}</p>
                            <p>{{$t('pages.exams.start')}}: {{ kviz.classExams[0].startsAt | formatDate }}</p>
                            <p v-if="kviz.classExams[0].finishesAt != null"> {{$t('pages.exams.finishTime')}}: {{kviz.classExams[0].finishesAt | formatDate}} </p>
                            <p> {{$t('pages.group.duration')}}: {{kviz.classExams[0].duration/1000/60}} min</p>
                            <p v-if="kviz.show_one_exercise" class="text-red" style="font-weight: bold;">{{$t('pages.exams.oneExerciseAtATimeWarning')}}</p>
                          </div>
                          <div class="box" v-if="attemptHistory.length > 0">
                            <div class="box-body no-padding">
                              <table class="table">
                                <tbody>
                                  <tr>
                                    <th style="width: 3em">{{$t('pages.exams.attemptHistory.attempt')}}</th>
                                    <th v-if="!detectMobile()">{{$t('pages.exams.attemptHistory.startedAt')}}</th>
                                    <th v-if="!detectMobile()">{{$t('pages.exams.attemptHistory.finishedAt')}}</th>
                                    <th v-if="detectMobile()">{{$t('pages.exams.attemptHistory.status')}}</th>
                                    <th>{{$t('pages.exams.attemptHistory.grade')}}</th>
                                  </tr>
                                  <tr v-for="(poskus, i) in attemptHistory">
                                    <td>{{i + 1}}.</td>
                                    <td v-if="!detectMobile()">{{poskus.startedAt | formatDate}}</td>
                                    <td v-if="!detectMobile()">{{poskus.finishedAt | formatDate}}</td>
                                    <td v-if="detectMobile() && kviz.classExams[0].isSolving && kviz.classExams[0].examId === poskus.id">{{$t('pages.exams.attemptHistory.inProgress')}}</td>
                                    <td v-if="detectMobile() && !(kviz.classExams[0].isSolving && kviz.classExams[0].examId === poskus.id)">{{$t('pages.exams.attemptHistory.finished')}}</td>
                                    <td v-if="poskus.points != null && poskus.maxPoints">
                                      <div class="progress progress-xs">
                                        <div v-if="100 * poskus.points / poskus.maxPoints >= 50" class="progress-bar progress-bar-green" :style="{width: (100 * poskus.points / poskus.maxPoints) + '%'}"></div>
                                        <div v-else class="progress-bar progress-bar-danger" :style="{width: (100 * poskus.points / poskus.maxPoints) + '%'}"></div>
                                      </div>
                                    </td>
                                    <td v-else>{{$t('pages.exams.attemptHistory.unavailable')}}</td>
                                    <td v-if="poskus.points != null && poskus.maxPoints">
                                      <span v-if="(100 * poskus.points / poskus.maxPoints) >= 50" class="badge bg-green">{{(100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'}}</span>
                                      <span v-else class="badge bg-red">{{(100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'}}</span>
                                    </td>
                                    <td class="pull-right" v-if="kviz.showResult" @click.prevent="showFullAttempt(poskus, kviz)"><a href="#">{{$t('pages.exams.attemptHistory.showAttempt')}}</a></td>
                                    <td v-else></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="form-group" v-if="kviz.classExams[0].passwordRequired">
                            <label class="control-label">{{$t('pages.register.password')}}:</label>
                            <div class="">
                              <input type="password" class="form-control" v-model="modalStartExam.examPassword">
                            </div>
                          </div>
                          <div class="form-group">
                            <div>
                              <a @click.prevent="zacniResevanjeIzpita(kviz)" class="btn btn-primary pull-right" :class="[{'disabled': (kviz.classExams[0].maxRetries > 0 && kviz.classExams[0].maxRetries - kviz.classExams[0].retriesCount <= 0 && !adminView)}]">
                                {{$t('pages.exams.begin')}}
                              </a>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                          <div id="" class="">
                            <div v-if="modalStartExam.statusText !== ''" class="help-block text-center">{{modalStartExam.statusText}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal modal-default fade" :id="'error-kviz' + kviz.id">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                        <h4 class="modal-title">{{$t('pages.exams.examinationInfo')}}</h4>
                      </div>
                      <div class="modal-body">
                        {{$t('pages.exams.examNotScheduled')}}
                        <a @click.prevent="goToEditExam(kviz)">{{$t('pages.exams.goToEditExam')}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- Quizes -->

      <div v-if="sid === 'root' && !detectMobile()" class="small-box info-box containter-full" v-for="(subgroup, jIndeks) in seznamPodskupin" :key="'podskupina-'+jIndeks" :class="[defaultGColor]">
        <div class="group-box " @click.prevent="showExercises(subgroup)">
          <span class="info-box-icon">
              <i class="fa fa-folder" v-if="subgroup.subgroupsCount && subgroup.subgroupsCount != 0"></i>
              <i class="fa fa-pencil" v-else-if="subgroup.totalQuestionsCount && subgroup.totalQuestionsCount != 0"></i>
              <i class="fa fa-question" v-else></i>
          </span>
          <div class="info-box-content">
            <h3 class="info-box-number">
              <div :id="'dropdown-'+jIndeks" class="dropdown pull-right">
                <button type="button" id="youtubeLinkButton" v-if="subgroup.youtube_link != null" class="btn btn-secondary pull-right" style="margin-top: 0.5em; margin-left: 0.1em" @click.prevent.stop="toggleVideo(subgroup.youtube_link, subgroup.youtube_time)">
                  <i class="glyphicon glyphicon-play"></i>
                </button>
                <button v-if="adminView" :id="'dropdownMenuButton-'+jIndeks" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown" class="btn btn-secondary dropdown-toggle" @click.prevent.stop="toggleDropdown(jIndeks, seznamPodskupin.length)">
                  <span class="fa fa-cog"></span>
                  <span class="fa fa-caret-down"></span>
                </button>
                <div role="menu" class="dropdown-menu">
                  <li v-if="jeAdmin"><a @click.prevent.stop="showExercisesIdentifiers(subgroup)">{{$t('pages.subgroups.showExercises')}}</a></li>
                  <li><a v-if="adminView" @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); toggleShowEdit(subgroup, jIndeks);">{{$t('pages.subgroups.editSubgroup')}}</a></li>
                  <li v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && adminView && !subgroup.dynamic"><a @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); orderTopic(subgroup, jIndeks)">{{$t('pages.subgroups.editExercises')}}</a></li>
                  <li v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && adminView && subgroup.dynamic"><a @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); showEditRules(subgroup, jIndeks)">{{$t('pages.subgroups.editRules.editRules')}}</a></li>
                  <li v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && adminView && subgroup.dynamic"><a @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); showPreview(subgroup, indeks)">{{$t('pages.subgroups.previewExercises')}}</a></li>

                </div>
              </div>
              <!--<div class="btn-group pull-right" v-if="adminView">-->
                <!--<button type="button" class="btn btn-default" @click.prevent.stop="showExercises(subgroup)">-->
                  <!--<i class="fa fa-sign-in"></i>-->
                <!--</button>-->
                <!--<button type="button" class="btn btn-default" @click.prevent.stop="toggleShowEdit(subgroup, jIndeks)">-->
                  <!--<i class="fa fa-edit"></i>-->
                <!--</button>-->
                <!--<button type="button" class="btn btn-default" @click.prevent.stop="orderTopic(subgroup, jIndeks)" v-if="subgroup.subgroupsCount == 0">-->
                  <!--<i class="fa fa-reorder"></i>-->
                <!--</button>-->
              <!--</div>-->
              <!--<span style="font-size: 4vw">-->
                <div v-html="$options.filters.pickTranslation(subgroup.name)"></div>
              <!--</span>-->
            </h3>
            <div class="progress">
              <div class="progress-bar" :style="{width: (subgroup.totalSolvedQuestionsCount / subgroup.totalQuestionsCount)*100 + '%'}"></div>
            </div>
            <span v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0)" class="pull-right">{{subgroup.totalSolvedQuestionsCount}}/{{subgroup.totalQuestionsCount}} questions (total {{subgroup.exercisesCount}} exercises)</span>
              <span class="pull-right" v-else>{{subgroup.totalSolvedQuestionsCount}}/{{subgroup.totalQuestionsCount}} questions (total {{subgroup.subgroupsCount}} subgroups)</span>
            <span class="progress-description">
              {{ subgroup.description | pickTranslation }}&nbsp;
               <span v-if="jeAdmin">
              ({{subgroup.exercisesCount}} exercises)
            <br> <span v-if="forWhichSubgroup == subgroup.name"><span v-for="el in exerciesesIdentifiers">{{el}}<br></span></span>
              </span>
            </span>
          </div>
        </div>
        <div v-if="subgroup.showEdit" class="small-box-footer">
          <editsubgroup :podgrupa="subgroup"></editsubgroup>
        </div>
        <div v-if="subgroup.showOrder" class="small-box-footer">
          <editRules :podgrupa="subgroup" v-if="subgroup.dynamic" ref="editRules"></editRules>
          <orderexer :podgrupa="subgroup" v-else></orderexer>
        </div>
        <div v-if="subgroup.dynamic && subgroup.showPreview">
          <previewExer :podgrupa="subgroup" v-if="subgroup.dynamic" ref="previewExercise"></previewExer>
        </div>
      </div>

    </div>

    <!-- NEW PRIKAZ SKUPIN -->
    <div v-if="!hideGroups">
      <div>
        <!-- Ime Skupine -->
        <div v-if="(adminView || subgroup.visible) && (sid != 'root'||detectMobile())" :key="'show-evercises-'+subgroup.id" v-for="(subgroup, index) in seznamPodskupin" :class="['no-padding-box', 'content', defaultGColor, 'subgroup-box', 'info-box', 'containter-fluid']">
          <div  @click.prevent="showExercises(subgroup)" class="group-box">
          <span v-if="!detectMobile()" class="small-icon info-box-icon" :class="[]">
              <i class="fa fa-folder" v-if="subgroup.subgroupsCount && subgroup.subgroupsCount != 0"></i>
              <i class="fa fa-pencil" v-else-if="subgroup.totalQuestionsCount && subgroup.totalQuestionsCount != 0"></i>
              <i class="fa fa-question" v-else></i>
          </span>
          <div style="padding: 10px">
            <button type="button" v-if="subgroup.youtube_link != null" class="btn btn-default pull-right" style="margin-left: 0.25em;" @click.prevent.stop="toggleVideo(subgroup.youtube_link, subgroup.youtube_time)">
              <i class="glyphicon glyphicon-play"></i>
            </button>
            <div :id="'dropdown-'+index" class="dropdown pull-right" v-if="adminView">
              <button :id="'dropdownMenuButton-'+index" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown" class="btn btn-secondary btn-sm dropdown-toggle" @click.prevent.stop="toggleDropdown(index, seznamPodskupin.length)">
                <span class="fa fa-cog"></span>
                <span class="fa fa-caret-down"></span>
              </button>
              <div role="menu" class="dropdown-menu">
                <li v-if="jeAdmin"><a @click.prevent.stop="showExercisesIdentifiers(subgroup)">{{$t('pages.subgroups.showExercises')}}</a></li>
                <li><a v-if="adminView" @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); toggleShowEdit(subgroup, index);">{{$t('pages.subgroups.editSubgroup')}}</a></li>
                <li v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && adminView && !subgroup.dynamic"><a @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); orderTopic(subgroup, index)">{{$t('pages.subgroups.editExercises')}}</a></li>
                <li v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && adminView && subgroup.dynamic"><a @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); showEditRules(subgroup, indeks)">{{$t('pages.subgroups.editRules.editRules')}}</a></li>
                <li v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0) && adminView && subgroup.dynamic"><a @click.prevent.stop="closeAllDropdowns(seznamPodskupin.length); showPreview(subgroup, indeks)">{{$t('pages.subgroups.previewExercises')}}</a></li>
              </div>
            </div>
          <h3 class="small-margin-text info-box-number" :class="{'left-margin-text':!detectMobile()}">
            <span v-if="detectMobile()">
              <i class="fa fa-folder" v-if="subgroup.subgroupsCount && subgroup.subgroupsCount != 0"></i>
              <i class="fa fa-pencil" v-else-if="subgroup.totalQuestionsCount && subgroup.totalQuestionsCount != 0"></i>
              <i class="fa fa-question" v-else></i>
            </span>
            {{index+1}}. {{ subgroup.name | pickTranslation }}
          </h3>
          <div class="progress">
            <div class="progress-bar" :style="{width: (subgroup.totalSolvedQuestionsCount / subgroup.totalQuestionsCount)*100 + '%'}"></div>
          </div>
          <span v-if="(!subgroup.subgroupsCount || subgroup.subgroupsCount == 0)" class="pull-right">{{subgroup.totalSolvedQuestionsCount}}/{{subgroup.totalQuestionsCount}} questions (total {{subgroup.exercisesCount}} exercises)</span>
            <span class="pull-right" v-else>{{subgroup.totalSolvedQuestionsCount}}/{{subgroup.totalQuestionsCount}} questions (total {{subgroup.subgroupsCount}} subgroups)</span>
          <span class="small-margin-text progress-description" :class="{'left-margin-text':!detectMobile()}">

            {{ subgroup.description | pickTranslation }} &nbsp;
            <span v-if="jeAdmin">
            ({{subgroup.exercisesCount}} exercises)
            <br> <span v-if="forWhichSubgroup == subgroup.name"><span v-for="el in exerciesesIdentifiers">{{el}}<br></span></span>
            </span>
          </span>

          </div>
          </div>
          <div v-if="subgroup.showOrder" class="small-box-footer">
            <div style="overflow: auto; width: 100%; text-align: center">
              <editRules :podgrupa="subgroup" v-if="subgroup.dynamic" ref="editRules"></editRules>
              <orderexer :podgrupa="subgroup" v-else></orderexer>
            </div>
          </div>
          <div v-if="subgroup.dynamic && subgroup.showPreview">
            <previewExer :podgrupa="subgroup" v-if="subgroup.dynamic" ref="previewExercise"></previewExer>
          </div>
          <div v-if="subgroup.showEdit" class="small-box-footer">
            <editsubgroup :podgrupa="subgroup"></editsubgroup>
          </div>
        </div>
      </div>
    </div>
    <div v-if="seznamPodskupin && seznamPodskupin.length > 2">
      <div v-if="detectMobile()" style="overflow: scroll;">
        <div style="min-width: 600px; min-height: 600px">
          <spider-chart :seznamPodskupin="seznamPodskupin"></spider-chart>
        </div>
      </div>
      <spider-chart :seznamPodskupin="seznamPodskupin" v-else></spider-chart>
    </div>
    <!-- HINT AND SOLUTION MODAL -->
    <div class="modal modal-default fade" id="modal-addExam">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.createExam')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group exam-name">
              <label class="control-label col-sm-2">{{$t('pages.exams.name')}}:</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" v-model="examName">
              </div>
            </div>
            <button class="btn btn-primary pull-right" @click.prevent="addExam">{{$t('pages.exams.createExam')}}</button>
            <div class="clearfix"></div>
          </div>
        </div>
      <!-- /.modal-content -->
      </div>
    <!-- /.modal-dialog -->
    </div>
    <!-- MODAL FOR EXERCISE PREVIEW -->
    <div class="modal modal-default fade" id="modal-show-exercise">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.preview')}}</h4>
          </div>
          <div class="modal-body">
            <exercise :bareBonesExercise="CelotnaNaloga"></exercise>
          </div>
          <div class="modal-footer">
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- MODAL FOR SEARCHING LIBRARY -->
    <div v-if="this.adminView" class="modal modal-default" id="modal-exercises-add" data-target="#modal-exercises-add">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.editExam.modals.searchExercises')}}</h4>
          </div>
          <div class="modal-body">
            <library></library>
          </div>
          <div class="modal-footer bg-primary">
            <button class="btn btn-default pull-left" @click.prevent="toggleExercisesModal()">{{$t('pages.exams.editExam.modals.cancel')}}</button>
            <button v-if="selectedExercises && selectedExercises.length > 0" class="btn btn-default" @click.prevent="addExercisesBulk()">{{$t('pages.exams.editExam.modals.add')}}</button>
            <button v-else class="btn btn-default disabled">{{$t('pages.exams.editExam.modals.add')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- MODAL FOR STRUCTURE IMPORT -->
    <div class="modal modal-default fade" :id="'importStructure'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{ $t('pages.subgroups.importStructure')}}</h4>
          </div>
          <div class="modal-body">
            <template>
              <form class="uploadForm" enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                <div class="dropbox">
                  <input type="file" name="file" :disabled="isSaving" @change="save(); fileCount = $event.target.files.length" accept=".yaml" class="input-file">
                  <p v-if="isInitial">
                    {{ $t('pages.subgroups.uploadSentence')}}<br> {{ $t('pages.subgroups.uploadSentence2')}}
                  </p>
                </div>
              </form>
            </template>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--Modal for viewing exam history-->
    <div class="modal modal-default fade" :id="'examHistoryModal'" v-if="adminView">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.attemptHistory.allExams')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="box">
                <div class="box-body no-padding">
                  <table class="table">
                    <tbody>
                    <tr>
                      <th>{{$t('pages.adminpanel.ratingStatistics.name')}}</th>
                      <th>{{$t('pages.exams.attemptHistory.startedAt')}}</th>
                      <th v-if="!detectMobile()">{{$t('pages.exams.attemptHistory.finishedAt')}}</th>
                      <th>{{$t('pages.exams.attemptHistory.grade')}}</th>
                    </tr>
                    <tr v-for="(poskus, i) in attemptHistory" v-bind:key="'ah-'+JSON.stringify(poskus)">
                      <td v-if="poskus.user">{{poskus.user.firstName}} {{poskus.user.lastName}}</td>
                      <td>{{poskus.startedAt | formatDate}}</td>
                      <td v-if="!detectMobile()">{{poskus.finishedAt | formatDate}}</td>
                      <td v-if="poskus.points != null && poskus.maxPoints">
                        <div class="progress progress-xs">
                          <div v-if="100 * poskus.points / poskus.maxPoints >= 50" class="progress-bar progress-bar-green" :style="{width: (100 * poskus.points / poskus.maxPoints) + '%'}"></div>
                          <div v-else class="progress-bar progress-bar-danger" :style="{width: (100 * poskus.points / poskus.maxPoints) + '%'}"></div>
                        </div>
                      </td>
                      <td v-else>{{$t('pages.exams.attemptHistory.unavailable')}}</td>
                      <td>
                        <div v-if="poskus.points != null && poskus.maxPoints">
                          <span v-if="(100 * poskus.points / poskus.maxPoints) >= 50" class="badge bg-green">{{(100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'}}</span>
                          <span v-else class="badge bg-red">{{(100 * poskus.points / poskus.maxPoints).toFixed(1) + '%'}}</span>
                        </div>
                      </td>
                      <td class="pull-right" @click.prevent="showExamAttempt(poskus.id)"><a href="#">{{$t('pages.exams.attemptHistory.showAttempt')}}</a></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="">
                <div v-if="modalStartExam.statusText !== ''" class="help-block text-center">{{modalStartExam.statusText}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <exam-results-preview ref="examResultsPreview"/>

    <div v-if="adminView" class="modal modal-default fade" :id="'reorderSubgroupsModal'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.subgroups.reorder')}}</h4>
          </div>
          <div class="modal-body">
            <reorder-subgroups :podskupine="seznamPodskupin" :skupinaId="gid" :podskupinaId="sid"></reorder-subgroups>
          </div>
        </div>
      </div>
    </div>

    <div class="modal modal-default fade" :id="'selectSubgroupsModal'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.ratingHistory.ratingQuiz')}}</h4>
          </div>
          <div class="modal-body">
            <span>{{$t('pages.exams.ratingResults.ratingQuizInfo')}}</span>
            <h4 class="modal-title"  style="margin: 20px 0 10px 0">{{$t('pages.subgroups.selectSubgroups')}}</h4>
            <span style="width: 100%; text-align: center;" v-if="loadingSubgroups">
              <pulse-loader :color="spinnerColor" :size="spinnerSize"></pulse-loader>
            </span>
            <template>
              <div class="form-group">
                <transition-group name="fade">
                  <div v-for="subgroup in filteredSubgroups" :key="subgroup.id">
                    <div :style="'margin-left: ' + (2 * subgroup.nivo) + 'em'">
                      <input v-if="subgroup.list" type="checkbox" :id="subgroup.id" :value="subgroup.id" v-model="izbranePodskupine">
                      <label :for="subgroup.id" @click.prevent="toggleSubgroup(subgroup)">
                        {{ !subgroup.list ? expandedSymbol(subgroup) : '' }} {{ subgroup.name | pickTranslation }}
                      </label>
                      <span
                          v-if="!subgroup.list"
                          @click.prevent="selectAllSbgroupsInTree(subgroup.id, true)"
                          class="text-light-blue pointer"
                      >
                        ({{$t('pages.subgroups.addAll')}})
                      </span>
                      <span
                          v-if="!subgroup.list"
                          @click.prevent="selectAllSbgroupsInTree(subgroup.id, false)"
                          class="text-light-blue pointer"
                      >
                        ({{$t('pages.subgroups.removeAll')}})
                      </span>
                    </div>
                  </div>
                </transition-group>
              </div>
            </template>

            <!--Izbira trajanja-->
            <div class="form-group">
              <label>{{$t('pages.subgroups.selectDuration')}}</label>
              <select class="form-control" v-model="izbranoTrajanje">
                <option value="20">20 min</option>
                <option value="30">30 min</option>
                <option value="45">45 min</option>
              </select>
            </div>

            <!--Admin moznosti-->
            <div class="form-group" v-if="adminView">
              <input type="checkbox" v-model="createQuiz"> {{$t('pages.subgroups.createQuizForOtherUsers')}}
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="createQuiz" class="btn btn-primary pull-right" data-dismiss="modal" @click.prevent="startRatingQuiz">{{$t('pages.subgroups.createQuiz')}}</button>
            <button v-else class="btn btn-primary pull-right" data-dismiss="modal" @click.prevent="startRatingQuiz">{{$t('pages.subgroups.startQuiz')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- modal for adding rules to dynamic groups-->
    <div class="modal modal-default fade" id="modal-addRule">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.subgroups.editRules.addRule')}}</h4>
          </div>
          <div class="modal-body">
            <div class="small-box-footer">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="input-group col-xs-10 margin">
                  <input v-model="sId" class="form-control input-sm" type="text" :placeholder="$t('pages.subgroups.editRules.identifier')">
                </div>
                <div class="input-group col-xs-10 margin">
                  <input v-model="stitle" class="form-control input-sm" type="text" :placeholder="$t('pages.exerciseList.placeholders.title')">
                </div>
                <div class="input-group col-xs-10 margin">
                  <input v-model="sauthor" class="form-control input-sm" type="text" :placeholder="$t('pages.exerciseList.placeholders.author')">
                </div>
                <div class="input-group col-xs-10 margin">
                  <input v-model="ssource" class="form-control input-sm" type="text" :placeholder="$t('pages.exerciseList.placeholders.source')">
                </div>
                <div class="margin col-xs-3">
                  <span>
                    <input v-model="sowner" type="checkbox"> {{$t('pages.exerciseList.owner')}}
                  </span>
                </div>
                <div class="margin col-xs-3">
                  <!-- <span>
                    <input v-model="spublic" type="checkbox"> {{$t('pages.exerciseList.public')}}
                  </span> -->
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="col-xs-12 margin">
                  <div class="input-group">
                    <v-select multiple v-model="stags" :options="options.tags" label="name" :placeholder="$t('pages.exerciseList.placeholders.tags')"></v-select>
                    <span class="input-group-addon">
                <button v-bind:class="{ 'bg-blue': sTagFilter === 'or' }" type="button" class="btn btn-xs" @click.prevent="updateTagFilter('or')">or</button>
                <button v-bind:class="{ 'bg-blue': sTagFilter === 'and' }" type="button" class="btn btn-xs" @click.prevent="updateTagFilter('and')">and</button>
              </span>
                  </div>
                </div>
                <div class="col-xs-12 margin">
                  <v-select multiple v-model="stagsExclude" :options="options.tags" label="name" :placeholder="$t('pages.exerciseList.placeholders.tagsExclude')"></v-select>
                </div>
                <div class="col-xs-12 margin">
                  <v-select multiple v-model="slangs" :options="options.lngs" label="name" :placeholder="$t('pages.exerciseList.placeholders.languages')"></v-select>
                </div>
                <div class="col-xs-12 margin">
                  <v-select multiple v-model="stypes" :options="options.types" label="name" :placeholder="$t('pages.exerciseList.placeholders.types')"></v-select>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-primary pull-right" v-if="editRuleId !== null" @click.prevent="editRule" style="margin-right: 20px">{{$t('pages.subgroups.editRules.editRule')}}</button>
            <button class="btn btn-primary pull-right" v-else @click.prevent="addNewRule" style="margin-right: 20px">{{$t('pages.subgroups.editRules.addRule')}}</button>
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal modal-danger fade" id="modal-beforeDelete">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.subgroups.editRules.deleteRuleModal')}}</h4>
          </div>
          <div class="modal-body">
            <p>{{$t('pages.subgroups.editRules.confirmDeleteMessage')}}</p>
          </div>

          <div class="modal-footer">
            <button class="btn btn-danger pull-left" @click.prevent="deleteRule">{{$t('pages.subgroups.editRules.deleteConfirm')}}</button>
            <button class="btn btn-primary pull-right" @click.prevent="toggleDeleteRule">{{$t('pages.subgroups.editRules.deleteCancel')}}</button>
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <!-- modal for adding rules to dynamic groups-->
    <div v-if="adminView" class="modal modal-default fade" id="detailsModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{statusType}}</h4>
          </div>
          <div class="modal-body">
            <div v-if="statusProgress == -1" class="text-red">
              <span v-if="statusType === 'YAML import'"> {{$t('pages.subgroups.yamlError')}}</span>
              <span v-else-if="statusType === 'Recompute group'"> {{$t('pages.subgroups.recomputeError')}}</span>
              <p>{{statusMessage}}</p>
            </div>
            <div v-else-if="statusProgress == 100" class="text-green">
              <div v-if="statusType === 'YAML import'">
                <span> {{$t('pages.subgroups.yamlSuccess')}}</span>
                <span>{{statusMessage}}</span>
              </div>
              <div v-else-if="statusType === 'Recompute group'">
                <span> {{$t('pages.subgroups.recomputeSuccess')}}</span>
                <small v-for="(subgroup, index) in statusMessage" :key="'status-'+index">{{subgroup}}<br></small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger pull-left" data-dismiss="modal">{{$t('pages.buttons.close')}}</button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <exercises-list :examExercises="examExercises.exercises" :selectedGroup="selectedGroup"></exercises-list>
    </div>

    <!--Modal for embedded videos-->
    <div class="modal modal-default fade" id="videoModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <!-- <h4 class="modal-title">{{$t('pages.exams.attemptHistory.allExams')}}</h4> -->
          </div>
          <div class="modal-body">
            <div class="text-center">
              <iframe width="789" height="444"
                frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Rest from './../../../services/rest'
  import router from './../../../router/router'
  import editsubgroup from './../../admin/group/EditSubgroup'
  import createsubgroup from './../../admin/group/CreateSubgroup'
  import orderexer from './../../admin/group/ExercisesInOrder'
  import editRules from './../../admin/group/EditSubgroupRules'
  import previewExer from './../../admin/group/ExercisesPreview'
  import Exercise from '@/components/exercises/Exercise.vue'
  import ExerciseResultsPreview from '@/components/exercises/ExerciseResultsPreview'
  import ExercisesList from '@/components/exercises/ExercisesList'
  import Library from '@/components/admin/Library.vue'
  import SpiderChart from '@/components/groups/SpiderChart'
  import { mapState, mapGetters } from 'vuex'
  import { saveAs } from 'file-saver/FileSaver'
  import vSelect from 'vue-select'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import ReorderSubgroups from './../../admin/group/ReorderSubgroups'
  import Bar from '@/charts/Bar.js'
  import Pie from '@/charts/Pie.js'
  import Line from '@/charts/Line.js'
  import ExamResultsPreview from '@/components/admin/group/ExamResultsPreview.vue'
  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    components: {
      editsubgroup,
      createsubgroup,
      orderexer,
      editRules,
      previewExer,
      bar: Bar,
      pie: Pie,
      'line-chat': Line,
      'exercise': Exercise,
      'exercises-list': ExercisesList,
      'library': Library,
      'spider-chart': SpiderChart,
      'v-select': vSelect,
      'reorder-subgroups': ReorderSubgroups,
      'pulse-loader': PulseLoader,
      'exercise-results-preview': ExerciseResultsPreview,
      'exam-results-preview': ExamResultsPreview
    },
    data () {
      return {
        forWhichSubgroup: '',
        exerciesesIdentifiers: '',
        dnevnaNaloga: [{ 'id': '1', 'name': 'dnevnaNaloga' }],
        showEdit: false,
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'file',
        fileCount: null,
        barva: null,
        indeks: 1,
        examExercises: {isShown: true},
        examName: '',
        modalStartExam: {
          examPassword: '',
          statusText: ''
        },
        opened: null,
        attemptHistory: [],
        // used for exam statistic inbrowser display
        exerciseNumber: 0,
        examResultsId: 0,
        examResults: null,
        resultsPerExercise: [],
        answersOfExercise: [],
        chartColors: [],
        chartBorderColors: [],
        currentExerciseData: [],
        correctAnswer: [],
        examsOpened: false,
        sId: '',
        stitle: '',
        sauthor: '',
        ssource: '',
        stags: [],
        sTagFilter: 'or',
        stagsExclude: [],
        slangs: [],
        stypes: [],
        sowner: true,
        spublic: false,
        options: {},
        openedSubgroup: null,
        editRuleId: null,
        subgroupArray: [],
        izbranePodskupine: [],
        izbranoTrajanje: 20,
        createQuiz: false,
        recomputeResponse: null,
        spinnerColor: '#3c8dbc',
        spinnerSize: '15px',
        loadingSubgroups: false,
        showNameOfQuestion: false,
        statusProgress: null,
        statusMessage: '',
        toggleStatus: false,
        statusInterval: '',
        statusType: '',
        toggleSolution: false,
        wholeParent: [],
        subgroupTreeData: null
      }
    },
    props: ['gid', 'yid', 'sid'],
    watch: {
      '$route' (to, from) {
        this.prepareComponent() // react to route changes... due to same component
      }
    },
    created () {
      this.prepareComponent()
    },
    destroyed () {
      this.$store.commit('destroySubgroupsBreadcrumbs')
      clearInterval(this.statusInterval)
    },
    methods: {
      goToLiterature () {
        if (!this.jeAdmin) {
          this.$router.push({name: 'literatureUser'})
        } else {
          this.$router.push({name: 'literatureAdmin'})
        }
      },
      navigateToFlow (id) {
        this.$router.push({name: 'solvingExamProgress', params: {examId: id}})
      },
      showExercisesIdentifiers (subgroup) {
        if (this.forWhichSubgroup !== '') {
          this.forWhichSubgroup = ''
          this.exerciesesIdentifiers = []
        } else {
          this.exerciesesIdentifiers = subgroup.exercisesCountIdentifiers.sort(function (a, b) {
            var nameA = a.toLowerCase()
            var nameB = b.toLowerCase()
            if (nameA < nameB) {
              return -1
            }
            if (nameA > nameB) {
              return 1
            }
            return 0
          })
          this.forWhichSubgroup = subgroup.name
        }
        // alert(subgroup.exercisesCountIdentifiers)
      },
      recomputeGroup () {
        this.recomputeResponse = null
        return Rest.request('POST', `/groups/${this.$route.params.gid}/recompute`).then((data) => {
          this.getStatus(this.gid, true)
        }).catch((err) => {
          this.recomputeResponse = {
            message: err.responseJSON.message
          }
          console.log(err)
        })
      },
      openDetailsModal () {
        window.jQuery('#detailsModal').modal('toggle')
      },
      startRatingQuiz () {
        console.log(this.izbranePodskupine)
        console.log(parseInt(this.izbranoTrajanje))

        let postdata = {
          subgroupIds: this.izbranePodskupine,
          testDuration: this.izbranoTrajanje,
          yearId: this.yid,
          createQuiz: this.createQuiz
        }
        Rest.request(`POST`, `/classExams/ratingQuiz`, postdata).then((data) => {
          let classExamId = data.classExamId
          let examId = data.examId
          if (this.createQuiz) {
            router.push({name: 'editExam', params: {examId: examId}})
          } else {
            Rest.request(`POST`, `/classExams/` + classExamId + `/start`, {}).then((data2) => {
              router.push({name: 'ratingExam', params: {classExamId: classExamId}})
            }).catch((err) => {
              console.log(err)
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      showRatingQuizSelection () {
        this.loadingSubgroups = true
        this.subgroupArray = []
        window.jQuery('#selectSubgroupsModal').modal('toggle')
        Rest.request(`GET`, `/subgroups/` + this.gid + `/subgroupTreeRating/` + this.sid).then((data) => {
          let tabela = []
          this.treeToArray(tabela, null, data, 0)
          this.subgroupArray = tabela
          this.loadingSubgroups = false
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(
              ['Typeset', window.MathJax.Hub]
            )
            /* var math = window.MathJax.Hub.getAllJax('exerciseStatList')[0]
            window.MathJax.Hub.Queue(['Text', math]) */
          })
        }).catch((err) => {
          console.log(err)
          this.loadingSubgroups = false
        })
      },
      closeAllSubgroups (subgroup) {
        this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              this.$set(s, 'expanded', false)
              if (s.expanded === false) {
                this.closeAllSubgroups(s)
              }
            }
          }
        })
      },
      expandAllSubgroups (subgroup) {
        var children = this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              return true
            }
            return false
          }
        })
        if (children.length > 0) {
          children.forEach(s => {
            this.$set(s, 'expanded', true)
            this.expandAllSubgroups(s)
          })
        }
      },
      toggleSubgroup  (subgroup) {
        this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              this.$set(s, 'expanded', !s.expanded)
              if (s.expanded === false) {
                this.closeAllSubgroups(s)
              }
            }
          }
        })
      },
      expandedSymbol (subgroup) {
        var children = this.subgroupArray.filter((s) => {
          if (s.parent != null) {
            if (s.parent.id === subgroup.id) {
              return true
            }
            return false
          }
        })

        var childrenExpanded = true
        children.forEach(element => {
          if (!element.expanded) {
            childrenExpanded = false
          }
        })

        return childrenExpanded ? '-' : '+'
      },
      selectAllSbgroupsInTree (id, value) {
        var subgroup = this.subgroupArray.filter((s) => {
          if (s.id === id) {
            return true
          }
          return false
        })[0]

        if (value) {
          this.expandAllSubgroups(subgroup)
        } else {
          this.closeAllSubgroups(subgroup)
        }

        for (let i = 0; i < this.subgroupArray.length; i++) {
          if (this.subgroupArray[i].id === id) {
            let j = i + 1
            let nivo = this.subgroupArray[i].nivo
            while (j < this.subgroupArray.length && this.subgroupArray[j].nivo > nivo) {
              if (this.subgroupArray[j].list) {
                if (value) {
                  if (!this.izbranePodskupine.includes(this.subgroupArray[j].id)) {
                    this.izbranePodskupine.push(this.subgroupArray[j].id)
                  }
                } else {
                  let th = this
                  this.izbranePodskupine = this.izbranePodskupine.filter(function (el) {
                    return el !== th.subgroupArray[j].id
                  })
                }
              }
              j++
            }
            break
          }
        }
      },
      toggleReorderSubgroups () {
        window.jQuery('#reorderSubgroupsModal').modal('toggle')
      },
      updateTagFilter (str) {
        this.sTagFilter = str
      },
      resetSearch () {
        this.sqlsid = ''
        this.stitle = ''
        this.sauthor = ''
        this.ssource = ''
        this.stags = []
        this.stagsExclude = []
        this.slangs = []
        this.stypes = []
        this.sowner = true
        this.spublic = false
      },
      showEditRules (tema, index) {
        this.openedSubgroup = tema
        for (var i = 0; i < this.seznamPodskupin.length; i++) {
          if (this.seznamPodskupin[i].showOrder === true && this.seznamPodskupin[i] !== tema) {
            this.$set(this.seznamPodskupin[i], 'showOrder', !this.seznamPodskupin[i].showOrder)
          }
        }
        this.$set(tema, 'showOrder', !tema.showOrder)
        if (!tema.showOrder) {
          // posodobi vse skupine
          Rest.request(`GET`, `/groups/${this.$route.params.gid}/years/${this.$route.params.yid}/subgroups/${this.$route.params.sid}`).then((data) => {
            let podskupine = data.subgroups.find(el => el.id === tema.id)
            this.$set(tema, 'totalQuestionsCount', podskupine.totalQuestionsCount)
          }).catch((err) => {
            console.log(err)
          })
        }
        this.getOptions()
      },
      showPreview (tema) {
        this.openedSubgroup = tema
        for (var i = 0; i < this.seznamPodskupin.length; i++) {
          if (this.seznamPodskupin[i].showPreview === true && this.seznamPodskupin[i] !== tema) {
            this.$set(this.seznamPodskupin[i], 'showPreview', !this.seznamPodskupin[i].showPreview)
          }
        }
        this.$set(tema, 'showPreview', !tema.showPreview)
      },
      getOptions () {
        return Rest.request('GET', '/exercises/searchOptions').then((data) => {
          this.options = data
        }).catch((err) => {
          console.log(err)
        })
      },
      toggleDeleteRule () {
        window.jQuery('#modal-beforeDelete').modal('toggle')
      },
      deleteRule () {
        this.$refs.editRules[0].deleteRule(this.editRuleId)
        this.toggleDeleteRule()
        if (this.$refs.previewExercise.length > 0) {
          this.$refs.previewExercise[0].refreshExercises()
        }
      },
      addNewRule () {
        let postdata = {
          identifier: this.sqlsid,
          title: this.sqltitle,
          author: this.sqlauthor,
          source: this.sqlsource,
          tagIds: this.sqltags,
          tagFilterType: this.sTagFilter,
          tagExcludeIds: this.sqltagsExclude,
          lngIds: this.sqllangs,
          typeIds: this.sqltypes,
          isOwner: this.sowner,
          isPublic: this.spublic
        }
        console.log(postdata)
        return Rest.request('POST', '/subgroups/' + this.openedSubgroup.id + '/rules', postdata).then((data) => {
          window.jQuery('#modal-addRule').modal('toggle')
          this.resetSearch()
          this.$refs.editRules[0].getRules()
          if (this.$refs.previewExercise.length > 0) {
            this.$refs.previewExercise[0].refreshExercises()
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      editRule () {
        let postdata = {
          identifier: this.sqlsid,
          title: this.sqltitle,
          author: this.sqlauthor,
          source: this.sqlsource,
          tagIds: this.sqltags,
          tagFilterType: this.sTagFilter,
          tagExcludeIds: this.sqltagsExclude,
          lngIds: this.sqllangs,
          typeIds: this.sqltypes,
          isOwner: this.sowner,
          isPublic: this.spublic
        }
        console.log(postdata)
        return Rest.request('PUT', '/subgroups/any/rules/' + this.editRuleId, postdata).then((data) => {
          window.jQuery('#modal-addRule').modal('toggle')
          this.resetSearch()
          this.$refs.editRules[0].getRules()
        }).catch((err) => {
          console.log(err)
        })
      },
      toggleExercisesModal () {
        window.jQuery('#modal-exercises-add').modal('toggle')
      },
      detectMobile () {
        if (navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/webOS/i) ||
          navigator.userAgent.match(/iPhone/i) ||
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/iPod/i) ||
          navigator.userAgent.match(/BlackBerry/i) ||
          navigator.userAgent.match(/Windows Phone/i)) {
          return true
        } else {
          return false
        }
      },
      addExercisesBulk () {
        if (this.tmpAddExercises != null) {
          let postdata = {
            exerciseIds: this.selectedExercises
          }
          return Rest.request('POST', '/subgroups/' + this.tmpAddExercises + '/exercises', postdata).then((data) => {
            window.jQuery('#modal-exercises-add').modal('toggle')
            this.updateOrder()
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      updateOrder () {
        this.$store.dispatch('exercisesForOrderGet', {
          gid: this.$route.params.gid,
          yid: this.$route.params.yid,
          pid: this.tmpAddExercises
        })
      },
      showExamInfo (kviz) {
        if (kviz.classExams.length === 0) {
          window.jQuery(`#error-kviz${kviz.id}`).modal('toggle')
          return
        }
        if (kviz.classExams[0].isSolving || (this.adminView && !kviz.classExams[0].passwordRequired)) {
          this.zacniResevanjeIzpita(kviz)
        } else {
          this.getAttemptHistory(kviz)
          window.jQuery(`#kviz${kviz.id}`).modal('toggle')
        }
      },
      getAttemptHistory (kviz) {
        this.attemptHistory = []
        return Rest.request('GET', `/classExams/${kviz.classExams[0].id}/attempts`).then((data) => {
          this.attemptHistory = data
          console.log(data)
        }).catch((err) => {
          console.log(err)
        })
      },
      goToEditExam (kviz) {
        window.jQuery(`#error-kviz${kviz.id}`).modal('toggle')
        router.push({name: 'editExam', params: {examId: kviz.id}})
      },
      showFullAttempt (attempt, exam) {
        let attemptId = attempt.id
        return Rest.request('GET', `/classExams/any/attempts/${attemptId}`).then((data) => {
          window.jQuery(`#kviz${exam.id}`).modal('toggle')
          router.push({name: 'classExamResults', params: {classExamId: attemptId}})
        }).catch((err) => {
          console.log(err)
        })
      },
      showExamAttempt (attemptId) {
        window.jQuery('#examHistoryModal').modal('toggle')
        router.push({name: 'classExamResultsAdmin', params: {classExamId: attemptId}})
      },
      zacniResevanjeIzpita (exam) {
        this.fetchExamExercises(exam)
      },
      fetchExamExercises (exam) {
        let classExamId = exam.classExams[0].id
        let postdata = {
          id: classExamId
        }
        if (exam.classExams[0].passwordRequired) postdata.password = this.modalStartExam.examPassword // TODO: test it
        if (exam.classExams[0].isSolving) {
          router.push({name: 'classExam', params: {classExamId: classExamId}})
          return
        } else {
          if (exam.liveTest) {
            if (!(this.adminView && !exam.classExams[0].passwordRequired) && !exam.classExams[0].isSolving) window.jQuery(`#kviz${exam.id}`).modal('toggle')
            if (exam.classExams.length > 0) {
              router.push({name: 'StopCheating', params: {selectedClassroom: exam.classExams[0].classroom, drawerOnly: false, quizID: exam.classExams[0].id}})
            }
          } else {
            return Rest.request('POST', `/classExams/${classExamId}/start`, postdata).then((data) => {
              if (!(this.adminView && !exam.classExams[0].passwordRequired) && !exam.classExams[0].isSolving) window.jQuery(`#kviz${exam.id}`).modal('toggle')
              if (exam.classExams.length > 0) {
                router.push({name: 'classExam', params: {classExamId: classExamId}})
              }
            }).catch((err) => {
              console.log(err)
            })
          }
        }
      },
      prepareComponent () {
        this.$store.commit(`updateSelectedGroup`, {group: {name: null}, subgroups: []})
        this.$store.dispatch('getGroup', {
          gid: this.gid,
          yid: this.yid,
          sid: this.sid
        }).then((data) => {
          this.subsetOfExercises = this.selectedGroup.subgroupExercises.slice(0, 2) || this.selectedGroup.subgroupExercises
          this.loading = true
          if (this.adminView) {
            this.getStatus(this.gid, true)
          }
        })
      },
      treeToArray (tabela, parent, drevo, nivo) {
        tabela.push({
          name: drevo.name,
          id: drevo.id,
          nivo: nivo,
          list: drevo.subgroups.length === 0,
          parent: parent,
          expanded: false
        })
        for (let i = 0; i < drevo.subgroups.length; i++) {
          var p = {
            name: drevo.name,
            id: drevo.id,
            nivo: nivo,
            list: drevo.subgroups.length === 0,
            parent: parent,
            expanded: false
          }
          this.treeToArray(tabela, p, drevo.subgroups[i], nivo + 1)
        }
      },
      showExercises (subgroup) {
        // router.push('/admin/' + this.gid + '/' + this.yid + '/exercises/' + subgroup.name + '/' + subgroup.id + '/' + 1)
        router.push({name: 'exercises', params: {sid: subgroup.id.toString(), gid: subgroup.groupId.toString(), yid: this.yid.toString()}})
        // router.push({name: 'adminExercise', params: { admin: 'admin', gid: this.gid, yid: this.yid, subgroup: this.$options.filters.pickTranslation(subgroup.name), pid: subgroup.id.toString(), nid: '1' }})
      },
      navigateDaily () {
        // if (this.dnevneNaloge.length > 0) {
        // router.push('/admin/' + this.gid + '/' + this.yid + '/dailyChallenges/' + 1 + '/' + 1 + '/' + 1)
        router.push({name: 'dailyChallengeAdmin', params: { admin: 'admin', gid: this.gid, yid: this.yid, dailyId: '1', exerciseVersionId: '1', nid: this.indeks.toString() }})
        // }
      },
      sendAjax (sId, indeks) {
        var form = window.jQuery('form[id=' + sId + ']')[0] // You need to use standard javascript object here
        var formData = new FormData(form)
        formData.append('subgroupId', sId)
        return Rest.requestForm('POST', '/importer/exerciseUpload', formData).then(function (data) {
        })
      },
      /*
      getSubGroups: function () {
        return Rest.request('GET', '/groups/' + this.gid + '/years/' + this.yid).then((data) => {
          this.barva = data.color
          this.seznamPodskupin = data.subgroups
          // this.dnevnaNaloga.showAdd = false
          this.$set(this.dnevnaNaloga, 'showAdd', false)
          // this.dnevneNaloge = data.dailyChallenges
          this.seznamPodskupin.forEach((podskupina, index) => {
            this.$set(this.seznamPodskupin[index], 'showEdit', false)
            this.$set(this.seznamPodskupin[index], 'showAdd', false)
            this.$set(this.seznamPodskupin[index], 'isUploading', false)
            this.$set(this.seznamPodskupin[index], 'showOrder', false)
            this.$set('seznamPodskupin[' + podskupina + ']', {
              showEdit: false,
              showAdd: false,
              isUploading: false,
              showOrder: false
            })
            // podskupina = Object.assign({}, podskupina, )
          })
          for (let podskupina of this.seznamPodskupin) {
            podskupina.showEdit = false
            podskupina.showAdd = false
            podskupina.isUploading = false
            podskupina.showOrder = false
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      */
      orderTopic (tema, index) {
        for (var i = 0; i < this.seznamPodskupin.length; i++) {
          if (this.seznamPodskupin[i].showOrder === true && this.seznamPodskupin[i] !== tema) {
            this.$set(this.seznamPodskupin[i], 'showOrder', !this.seznamPodskupin[i].showOrder)
          }
        }
        this.$set(tema, 'showOrder', !tema.showOrder)
        if (!tema.showOrder) {
          // posodobi stevilo nalog
          Rest.request(`GET`, `/groups/${this.$route.params.gid}/years/${this.$route.params.yid}/subgroups/${this.$route.params.sid}`).then((data) => {
            for (let i = 0; i < data.subgroups.length; i++) {
              if (data.subgroups[i].id === tema.id) {
                this.$set(tema, 'totalQuestionsCount', data.subgroups[i].totalQuestionsCount)
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      toggleDropdown (index, numberOfElements) {
        // window.jQuery('.dropdown-toggle').dropdown()
        if (window.jQuery('#dropdown-' + index).hasClass('open')) {
          window.jQuery('#dropdownMenuButton-' + index).attr('aria-expanded', false)
          window.jQuery('#dropdown-' + index).removeClass('open')
        } else {
          // zapiranje vseh ostalih popupov
          for (var i = 0; i < numberOfElements; i++) {
            window.jQuery('#dropdownMenuButton-' + i).attr('aria-expanded', false)
            window.jQuery('#dropdown-' + i).removeClass('open')
          }
          window.jQuery('#dropdownMenuButton-' + index).attr('aria-expanded', true)
          window.jQuery('#dropdown-' + index).addClass('open')
        }
      },
      closeAllDropdowns (numberOfElements) {
        for (var i = 0; i < numberOfElements; i++) {
          window.jQuery('#dropdownMenuButton-' + i).attr('aria-expanded', false)
          window.jQuery('#dropdown-' + i).removeClass('open')
        }
      },
      toggleExamsShown () {
        this.examsOpened = !this.examsOpened
      },
      openAddExam () {
        window.jQuery('#modal-addExam').modal('toggle')
      },
      addExam () {
        window.jQuery('#modal-addExam').modal('toggle')
        let postdata = {
          subgroupId: this.sid,
          yearId: this.yid,
          title: this.examName,
          isExam: true
        }
        if (postdata.subgroupId === 'root') {
          delete postdata.subgroupId
        }
        this.$snotify.async('', '', () => new Promise((resolve, reject) =>
          Rest.request('POST', '/exams', postdata).then((data) => {
            // this.prepareComponent()
            this.seznamKvizov.push(data)
            resolve({
              title: this.$t('pages.buttons.success'),
              config: {
                closeOnClick: true,
                timeout: 2000
              }
            })
            this.editTopic(data)
          }).catch((err) => {
            reject({
              title: this.$t('pages.buttons.fail'),
              config: {
                closeOnClick: true,
                timeout: 2000
              }
            })
            console.log(err)
            // tren.roleCreatedMsg = tren.$t('pages.buttons.fail')
          })
        ))
      },
      addChallenge: function () {
        this.$set(this.dnevnaNaloga, 'showAdd', !this.dnevnaNaloga.showAdd)
        // this.dnevnaNaloga.showAdd = !this.dnevnaNaloga.showAdd
        // this.$forceUpdate()
      },
      editDaily (exe, exeNm) {
        this.$store.commit('updateSelectedDaily', exe)
        this.indeks = exeNm
        this.isAnthingAlreadyColapsedDaily(2)
      },
      zacniResevanje (element, idSkupine) {
        return Rest.request('GET', '/exercises').then(function (data) {
          // router.push('/admin/' + idSkupine + '/exercises/subgroup/' + element.id)
        })
      },
      editTopic (tema) {
        router.push({name: 'editExam', params: { gid: this.gid, yid: this.yid, sid: this.sid, examId: tema.id }})
      },
      toggleShowEdit (tema) {
        this.$set(tema, 'showEdit', !tema.showEdit)
        tema.showEdit2 = !tema.showEdit2
        this.$forceUpdate()
      },
      reset () {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL
        this.uploadedFiles = []
        this.uploadError = null
      },
      refreshGroup () {
        this.toggleStatus = false
        this.currentStatus = STATUS_INITIAL
        this.$store.dispatch('getGroup', {
          gid: this.gid,
          yid: this.yid,
          sid: this.sid
        })
      },
      getStatus (gid, initInterval) {
        Rest.request('GET', `/groups/${gid}/status`).then((data) => {
          this.statusProgress = data.progress
          this.statusType = data.process
          console.log(this.statusType)
          if (this.statusType === 'Recompute group') {
            this.statusMessage = data.message.split('\n')
          } else {
            this.statusMessage = data.message
          }
          if (data.progress == null) {
            initInterval = false
          } else if (data.progress === 100) {
            this.currentStatus = STATUS_INITIAL
            initInterval = false
          } else if (data.progress === -1) {
            this.currentStatus = STATUS_FAILED
            initInterval = false
          } else {
            this.toggleStatus = true
          }
          if (initInterval) {
            this.setStatusInterval(gid)
          }
        }).catch((err) => {
          this.currentStatus = STATUS_FAILED
          console.log(err)
        })
      },
      setStatusInterval (gid) {
        this.toggleStatus = true
        this.statusInterval = setInterval(() => {
          if (this.statusProgress === 100 || this.statusProgress === -1) {
            clearInterval(this.statusInterval)
          }
          this.getStatus(gid, false)
        }, 3000)
      },
      async save () {
        // upload data to the server
        let formData = new FormData(window.jQuery('.uploadForm')[0])
        console.log(formData)
        console.log('neki')
        if (formData) {
          Rest.requestForm('POST', '/upload/group/' + this.gid, formData).then(x => {
            this.currentStatus = STATUS_SAVING
            window.jQuery('#importStructure').modal('toggle')
            this.getStatus(this.gid, true)
            window.jQuery('.uploadForm').find('input:file').val('')
          }).catch(err => {
            this.uploadError = err.response
            this.currentStatus = STATUS_FAILED
            alert(this.$t('pages.subgroups.errorMsg') + ((err.responseJSON && err.responseJSON.message) ? ('\n' + err.responseJSON.message) : ('')))
            this.reset()
            window.jQuery('.uploadForm').find('input:file').val('')
          })
        }
      },
      /*
      exercisesForProgressGetDaily () {
        var tren = this
        return Rest.request('GET', '/groups/' + this.gid + '/years/' + this.yid).then((data) => { // TODO: should be false in production
          tren.exercisesForProgress = data.dailyChallenges
          // this.filterNotActive()
          if (this.exercisesForProgress.length > 0) {
            this.selectedDaily = this.exercisesForProgress[0]
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      */
      filterNotActive () {
        this.exercisesForProgress = this.exercisesForProgress.filter((el) => !el.isActive)
      },
      colapseCreateDaily (meSelf) {
        this.isAnthingAlreadyColapsedDaily(meSelf)
        this.$store.commit('toggleCreateDaily')
      },
      colapseEditDaily (meSelf) {
        this.isAnthingAlreadyColapsedDaily(meSelf)
        this.$store.commit('toggleEditDaily')
      },
      colapseCreateSubgroup: function () {
        this.$store.commit('toggleCreateSubgroup')
      },
      isAnthingAlreadyColapsedDaily (meSelf) {
        if (!this.colED && meSelf !== 1) {
          this.$store.commit('toggleEditDaily')
        } else if (!this.colCD && meSelf !== 2) {
          this.$store.commit('toggleCreateDaily')
        }
      },
      getDaily: function () {
        if (this.exercisesForProgress.length > 0) {
          this.$store.commit('updateSelectedDaily', this.exercisesForProgress[0])
        }
      },
      showExamResults (kviz) {
        this.attemptHistory = []
        window.jQuery('#examHistoryModal').modal('toggle')
        for (let i = 0; i < kviz.classExams.length; i++) {
          return Rest.request('GET', `/classExams/${kviz.classExams[i].id}/allAttempts`).then((data) => {
            this.attemptHistory = data
            // Array.prototype.push.apply(this.attemptHistory, data)
            console.log(data)
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      exportCSV (id) {
        return Rest.requestForm('GET', '/results/' + id + '/csv').then((data) => {
          if (!data.message) {
            var blob = new Blob([data], {type: 'text/csv;charset=utf-8'})
            saveAs(blob, 'rezultati.csv')
          } else {
            Rest.Vue.$snotify.error(this.$t('alerts.results'), this.errorThrown)
          }
        })
      },
      openImport () {
        window.jQuery('#importStructure').modal('toggle')
      },
      exportGroup () {
        return Rest.requestForm('GET', '/groups/' + this.gid + '/export/' + this.sid).then((data) => {
          if (!data.message) {
            var blob = new Blob([data])
            saveAs(blob, 'group' + this.gid + '.tex')
          } else {
            Rest.Vue.$snotify.error(this.$t('alerts.results'), this.errorThrown)
          }
        })
      },
      toggleVideo (link, time) {
        // this.currentVideo = link.replace('watch?v=', '/embed/')
        link = link.replace('watch?v=', 'embed/')
        link = link + '?autoplay=1'
        if (time != null) {
          time = time.split(':')
          link = link + '&start=' + (parseInt(time[0]) * 60 + parseInt(time[1]))
        }
        // this.currentVideo = link
        window.jQuery('#videoModal iframe').attr('src', link)
        window.jQuery('#videoModal').modal('toggle')
      },
      goToGradebook () {
        router.push({name: 'gradebook', params: {yid: this.yid, gid: this.gid}})
      }
    },
    mounted () {
      this.reset()
      window.jQuery('#videoModal').on('hidden.bs.modal', function (e) {
        window.jQuery('#videoModal iframe').removeAttr('src')
      })
    },
    computed: {
      ...mapGetters({
        seznamPodskupin: 'getSubgroups',
        dnevneNaloge: 'getDailyChallenges',
        seznamKvizov: 'getExams',
        jeAdmin: 'hasAdminRole'
      }),
      ...mapState({
        defaultGColor: state => state.defaultGColor,
        selectedGroup: state => state.selectedGroup,
        colCS: state => state.adminpanel.exercises.colapseCreateSubgroup,
        colCD: state => state.adminpanel.exercises.colapseCreateDaily,
        colED: state => state.adminpanel.exercises.colapseEditDaily,
        exercisesForProgress: state => state.adminpanel.exercises.dailyChallenges,
        CelotnaNaloga: state => state.exerciseForModal,
        selectedDaily: state => state.adminpanel.exercises.selectedDaily,
        possibleColors: state => state.possibleColors,
        selectedExercises: state => state.exercises.selectedExercises,
        tmpAddExercises: state => state.tmpAddExercises
      }),
      hideGroups () {
        return !this.examExercises.isShown
      },
      areAnyExercises () {
        return !(this.examExercises && this.examExercises.isShown) || (this.selectedGroup && this.selectedGroup.subgroupExercises && this.selectedGroup.subgroupExercises.length > 0)
      },
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess () {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed () {
        return this.currentStatus === STATUS_FAILED
      },
      adminView () {
        return this.$route.meta.admin === true
      },
      sqltitle () {
        if (this.stitle !== '') {
          return '%' + this.stitle + '%'
        } else {
          return ''
        }
      },
      sqlauthor () {
        if (this.sauthor !== '') {
          return '%' + this.sauthor + '%'
        } else {
          return ''
        }
      },
      sqlsource () {
        if (this.ssource !== '') {
          return '%' + this.ssource + '%'
        } else {
          return ''
        }
      },
      sqltags () {
        return this.stags.map(nm => nm.id)
      },
      sqltagsExclude () {
        return this.stagsExclude.map(nm => nm.id)
      },
      sqllangs () {
        return this.slangs.map(nm => nm.id)
      },
      sqltypes () {
        return this.stypes.map(nm => nm.id)
      },
      sqlsid () {
        if (this.sId !== '') {
          return '%' + this.sId + '%'
        } else {
          return ''
        }
      },
      filteredSubgroups () {
        return this.subgroupArray.filter((subgroup) => {
          if (subgroup.expanded) {
            return true
          }
          // Display subgroups with parent set to null
          if (subgroup.parent === null) {
            return true
          }
          // Hide all other subgroups
          return false
        })
      }
    }
  }
</script>

<style scoped>

  .info-box-number {
    text-overflow: ellipsis;
    /* overflow: hidden; TODO: if uncommented butons do not work*/
    white-space: nowrap;
  }

  .container-full {
    margin: 0 auto;
    width: 100%;
  }

  .group-box {
    cursor: pointer;
  }
  .pointer {
    cursor: pointer;
  }
  .left-margin-text {
    margin-left: 75px;
  }
  .small-margin-text {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .no-padding-box {
    padding: 0px;
    padding-left: 0px;
    min-height: 70px;
  }
  .small-icon {
    height: 71px;
    width: 70px;
    line-height: 70px;
  }
  .createBtn {
    margin-right: 1em;
  }
  .exam-name {
    margin-bottom: 4em;
  }
  .fa-cog {
    color: black;
  }
  .fa-caret-down {
    color: black;
  }
  .progress-description {
    white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .info-box-icon {
    height: 100%;
  }
  .small-box > .small-box-footer:hover {
    color: rgba(255, 255, 255, 0.8);
    background: rgba(0, 0, 0, 0.1);
  }
  .btn-margin {
    margin-top: 5pt;
  }
  .loading-spinner {
    display: block;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
  }
  /* h3 {
    font-size: 1.3em;
  } */

  .just-padding {
    padding: 15px;
  }

  .list-group.list-group-root {
    padding: 0;
    overflow: hidden;
  }

  .list-group.list-group-root .list-group {
    margin-bottom: 0;
  }

  .list-group.list-group-root .list-group-item {
    border-radius: 0;
    border-width: 1px 0 0 0;
  }

  .list-group.list-group-root > .list-group-item:first-child {
    border-top-width: 0;
  }

  .list-group.list-group-root > .list-group > .list-group-item {
    padding-left: 30px;
  }

  .list-group.list-group-root > .list-group > .list-group > .list-group-item {
    padding-left: 45px;
  }

  .transparent-modal {
    opacity: 0 !important;
    filter: alpha(opacity=100) !important;
    background-color: rgba();
  }

  #youtubeLinkButton {
   color: black;
  }

  .loader {
    display: inline-block;
    position: relative;
    top: 4px;
  }

</style>



// WEBPACK FOOTER //
// Exercises.vue?bc2a4f7c